import React, { Component }        from 'react'
import { Redirect, Route, Switch ,NavLink } from 'react-router-dom'
import Loading                     from '../../../components/Loading'
import Admission                   from './Admission'
import Background                  from './Background'
import { getDetail,setSessionData }               from '../../../api/school'
import './index.less'
import imgTop from '../../../assets/svg/school_detail_banner_top.png';
import imgBottom from '../../../assets/svg/school_detail_banner_bottom.png';
class SchoolDetail extends Component {

  state = {
    loading: false,
    detail: null,
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    if(this.props.location.state){
        const {currentPage,schoolId,schoolList,searchVal,filter}=this.props.location.state;
        setSessionData('currentPage', currentPage);
        setSessionData('schoolId', schoolId);
        setSessionData('schoolList', schoolList);
        searchVal&&setSessionData('searchVal', searchVal);
        filter&&setSessionData('filter', filter);
    }
    getDetail(id)
    .then(({ data }) => {
      this.setState({ detail: data })
    })
    .finally(() => {
      this.setState({ loading: false })
    })
  }
  render() {
    const { detail, loading } = this.state;
    const { match, history } = this.props;
    if (loading) {
      return <div>loading...</div>
    } else {
      if (detail) {
        return (
          <div className="college-detail" style={{paddingBottom:typeof (this.props.onBack)==='function'?'42px':'0'}}>
            <div className="banner" >
              <img className='banner-img img-top' src={imgTop} alt=""/>
                {/*{typeof (this.props.onBack)==='function'?*/}
                {/*    <div className='title-and-add-box'>*/}
                {/*        <h1>{detail.name}</h1>*/}
                {/*        {this.props.renderOperationBtn(detail)}*/}
                {/*    </div>*/}
                {/*:*/}
                    <h1>{detail.name}</h1>
                {/*}*/}
              <div className="college-info">
                <div>
                  <p className="attribute-first">{detail.type==20?'本科':'专科'} / {detail.category.name}</p>
                  <p className="attribute">{detail.memberof} / {detail.creation}年创立</p>
                  <p className="attribute">{detail.provinceName}-{detail.cityName}</p>
                  <p>
                    {detail.is985 && <label>985</label>}
                    {detail.is211 && <label className="tag-211">211</label>}
                    {detail.isDoubleTop && <label className="tag-doubleTop">双一流</label>}
                  </p>
                </div>
                <img
                    src={detail.logoUrl}
                    className={`${detail.id==313||detail.id==319||detail.id==471||detail.id==478?'college-logo':''}`}
                    //↑解决：985&211&双一流的这四个学校的logo太大会把左侧标签挤下去
                    alt="college logo"
                />
              </div>
              <img className='banner-img img-bottom' src={imgBottom}  alt=""/>
            </div>
            <div className="tab-switch">
              <NavLink to={`${match.url}/background`} activeClassName="active">基本情况</NavLink>
              <NavLink to={`${match.url}/admission`} activeClassName="active">录取查询</NavLink>
            </div>
            <Switch>
              <Route path={`${match.url}/background`}
                     render={() => <Background detail={detail} match={match} history={history} onBack={this.props.onBack} hideBottomBtn={this.props.hideBottomBtn}/>}/>
              <Route path={`${match.url}/admission`}
                     render={() => <Admission detail={detail} match={match} history={history} onBack={this.props.onBack} hideBottomBtn={this.props.hideBottomBtn}/> }/>
              <Redirect from={`${match.url}`} to={`${match.url}/background`}></Redirect>
            </Switch>
          {typeof (this.props.onBack)==='function' && this.props.renderOperationBtn(detail)}
          </div>
        )
      } else {
        return (
          <Loading/>
        )
      }
    }
  }
}

export default SchoolDetail



// WEBPACK FOOTER //
// ./src/pages/School/Detail/index.js